import React, { Fragment, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from "reactstrap";

import Tabs, { TabPane } from "rc-tabs";
import TabContent from "rc-tabs/lib/SwipeableTabContent";
import ScrollableInkTabBar from "rc-tabs/lib/ScrollableInkTabBar";

import ComplaintCategoriesTab from "./OtherSettings/ComplaintCategoriesTab";

const OtherSettings = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
  }, []);

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="app-page-title mb-1">
            <div className="page-title-wrapper">
              <div className="page-title-heading fw-bold">
                <div className="page-title-icon">
                  <i className="pe-7s-settings icon-gradient bg-tempting-azure" />
                </div>
                <div>
                  {t("Other Settings")}
                  <div className="page-title-subheading">
                    {t("Manage system categories and types")}
                  </div>
                </div>
              </div>
              <div className="page-title-actions">
                <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                  {t("Back")}
                </button>
              </div>
            </div>
          </div>

          <Row>
            <Col md="12">
              <Tabs 
                defaultActiveKey="1" 
                renderTabBar={() => <ScrollableInkTabBar />} 
                renderTabContent={() => <TabContent />}
              >
                <TabPane tab={t('Complaint Categories')} key="1">
                  <ComplaintCategoriesTab />
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        </div>
      </div>
    </Fragment>
  );
};

export default OtherSettings;

